/* import __COLOCATED_TEMPLATE__ from './lite-seats-conversion-popover.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    isPlanEssential: boolean;
  };
  Blocks: {
    default: [];
  };
}

const LiteSeatsConversionPopoverComponent = templateOnlyComponent<Signature>();

export default LiteSeatsConversionPopoverComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::AnnualManageSubscription::LiteSeatsConversionPopover': typeof LiteSeatsConversionPopoverComponent;
    'billing/annual-manage-subscription/lite-seats-conversion-popover': typeof LiteSeatsConversionPopoverComponent;
  }
}
